/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SeedPrebuiltInitiativeResponseDto
 */
export interface SeedPrebuiltInitiativeResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof SeedPrebuiltInitiativeResponseDto
     */
    created?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SeedPrebuiltInitiativeResponseDto
     */
    skipped?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SeedPrebuiltInitiativeResponseDto
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof SeedPrebuiltInitiativeResponseDto
     */
    executionPlanId?: string;
    /**
     * 
     * @type {number}
     * @memberof SeedPrebuiltInitiativeResponseDto
     */
    taskCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SeedPrebuiltInitiativeResponseDto
     */
    executionPlanIds?: Array<string>;
}

/**
 * Check if a given object implements the SeedPrebuiltInitiativeResponseDto interface.
 */
export function instanceOfSeedPrebuiltInitiativeResponseDto(value: object): value is SeedPrebuiltInitiativeResponseDto {
    return true;
}

export function SeedPrebuiltInitiativeResponseDtoFromJSON(json: any): SeedPrebuiltInitiativeResponseDto {
    return SeedPrebuiltInitiativeResponseDtoFromJSONTyped(json, false);
}

export function SeedPrebuiltInitiativeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeedPrebuiltInitiativeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'created': json['created'] == null ? undefined : json['created'],
        'skipped': json['skipped'] == null ? undefined : json['skipped'],
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'executionPlanId': json['executionPlanId'] == null ? undefined : json['executionPlanId'],
        'taskCount': json['taskCount'] == null ? undefined : json['taskCount'],
        'executionPlanIds': json['executionPlanIds'] == null ? undefined : json['executionPlanIds'],
    };
}

export function SeedPrebuiltInitiativeResponseDtoToJSON(json: any): SeedPrebuiltInitiativeResponseDto {
    return SeedPrebuiltInitiativeResponseDtoToJSONTyped(json, false);
}

export function SeedPrebuiltInitiativeResponseDtoToJSONTyped(value?: SeedPrebuiltInitiativeResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created': value['created'],
        'skipped': value['skipped'],
        'initiativeId': value['initiativeId'],
        'executionPlanId': value['executionPlanId'],
        'taskCount': value['taskCount'],
        'executionPlanIds': value['executionPlanIds'],
    };
}

